
import React from 'react';

import { Container, Row, Col, Spinner, Button } from 'react-bootstrap';


import Expansion from './Expansion';

import {timedateUnconvert} from './Library';

import {HostingFirstStageContent} from './Epdhosting';
import {BackupFirstStageContent} from './Epdbackupstatus';
import {UptimeFirstStageContent} from './Epduptime';
import {RegistrarFirstStageContent} from './Epdregistrar';
import {EmailFirstStageContent} from './Epdemail';

const SummaryFirstStageContent = (obj) => {
   // const container = {}

    const Hosting   = HostingFirstStageContent(obj);
    const Backup    = BackupFirstStageContent(obj);
    const Monitor   = UptimeFirstStageContent(obj);
    const Registrar = RegistrarFirstStageContent(obj);
    const Email     = EmailFirstStageContent(obj);

    //console.log('Registrar', Registrar, Hosting);

    //const container = {...Hosting, ...Backup, ...Monitor, Registrar: Registrar};
    const container = {Hosting: Hosting, Backup: Backup, Monitor: Monitor, Registrar: Registrar, Email: Email};

    console.log('Container', container);

    return (container);
}




class StatusInformation extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {expand: [false, false, false] };
        
        this.expand = this.expand.bind(this);
    }


    expand = (index) => {
        const newState = this.state.expand;

        if (newState[index]) {
            // here if index is currently expanded
            newState[index] = false; 
        } else {
            // here if index item is currently not expanded
            newState.forEach((element, index) => newState[index] = false); 
            newState[index] = true; 
        } 

        this.setState({expand: newState});
    }
     


    render() {

        if (this.props.data.length === 0) { // if no data then do nothing
            return null
        }

        const expand = this.state.expand;

        //const reIndex = 3;
        const upIndex = 2;
        const baIndex = 1;
        const hoIndex = 0;

        const upState = expand[upIndex];
        const baState = expand[baIndex];
        const hoState = expand[hoIndex];

        const upCols = upState ? 4 : 1;
        const baCols = baState ? 4 : 1;
        const hoCols = hoState ? 3 : 1;

        //console.log(this.props.data)

        const firststage = this.props.data.map((obj) => {
            return SummaryFirstStageContent(obj);
        })

        /*
                    <td className={obj.Backup.TDnotziplmDays}>{obj.Backup.notzipLastModified}</td>
                <td className={obj.Backup.TDziplmDays}>{obj.Backup.zipLastModified}</td>
                {baState && <td className={obj.Backup.TDnotzipfmDays}>{obj.Backup.notzipFirstModified}</td>}
                {baState && <td className={obj.Backup.TDzipfmDays}>{obj.Backup.zipFirstModified}</td>}

        */

        const backupDisplay = (baState, obj) => {


            if (!baState) {
                var lastModified;
                var fmDays;

                if (timedateUnconvert(obj.Backup.notzipLastModified) < timedateUnconvert(obj.Backup.zipLastModified)) {
                    lastModified = obj.Backup.notzipLastModified;
                    fmDays       = obj.Backup.TDnotziplmDays ;
                } else {
                    lastModified = obj.Backup.zipLastModified;
                    fmDays       = obj.Backup.TDziplmDays ;
                }

                //const lastModified   = (obj.Backup.notzipLastModified >= obj.Backup.zipLastModified) ? obj.Backup.notzipLastModified   : obj.Backup.zipLastModified;
                //const fmDays         = (obj.Backup.notzipLastModified >= obj.Backup.zipLastModified) ? obj.Backup.TDnotziplmDays       : obj.Backup.TDziplmDays;
                return (
                    <>
                    <td className={fmDays}>{lastModified}</td>
                    </>
                )
            } else {
                return (
                    <>
                    <td className={obj.Backup.TDnotziplmDays}>{obj.Backup.notzipLastModified}</td>
                    <td className={obj.Backup.TDziplmDays}>{obj.Backup.zipLastModified}</td>

                    <td className={obj.Backup.TDnotzipfmDays}>{obj.Backup.notzipFirstModified}</td>
                    <td className={obj.Backup.TDzipfmDays}>{obj.Backup.zipFirstModified}</td>
                    </>
                )
            }
        }

        const listing = firststage.map((obj) => (
            <tr className="SummaryStatusRow" key={obj.Hosting.domain}>
                <td className="number">{obj.Hosting.Item}</td>
                <td className="domain"><a href={obj.Hosting.Url}>{obj.Hosting.domain}</a></td>
                
                <td className={obj.Monitor.TDstatus}>{obj.Monitor.status}</td>
                {upState && <td className={obj.Monitor.TDuptimes[0]}>{(obj.status !== "") && (obj.Monitor.uptimes[0] !== "") && parseFloat(obj.Monitor.uptimes[0]).toFixed(2)}</td>}
                {upState && <td className={obj.Monitor.TDuptimes[1]}>{(obj.status !== "") && (obj.Monitor.uptimes[1] !== "") && parseFloat(obj.Monitor.uptimes[1]).toFixed(2)}</td>}
                {upState && <td className={obj.Monitor.TDuptimes[2]}>{(obj.status !== "") && (obj.Monitor.uptimes[2] !== "") && parseFloat(obj.Monitor.uptimes[2]).toFixed(2)}</td>}

                {backupDisplay(baState, obj)}

                <td className={obj.Hosting.TDsuspended}>{obj.Hosting.suspended}</td>
                {hoState && <td className={obj.Hosting.TDdiskpercent}>{obj.Hosting.diskpercent}</td>}
                {hoState && <td className={obj.Hosting.TDbandpercent}>{obj.Hosting.bandpercent}</td>}

                <td className={obj.Email.TDstatus}>{obj.Email.status}</td>

                <td className={obj.Registrar.TDexpiration_date}>{obj.Registrar.expiration_date}</td>


            </tr>
        ))



        const output = [
            <table className="SummaryStatusTable" key="SummaryStatusTable">
                <tbody>
                    <tr>
                        <th className="SummaryStatusTitleBlank"></th>
                        <th className="SummaryStatusTitleBlank"></th>
                        <th className="SummaryStatusTitle" colSpan={upCols}><Expansion index={upIndex} title={"Uptime"}  states={this.state.expand} toggle={this.expand}/></th>
                        <th className="SummaryStatusTitle" colSpan={baCols}><Expansion index={baIndex} title={"Backups"} states={this.state.expand} toggle={this.expand}/></th>
                        <th className="SummaryStatusTitle" colSpan={hoCols}><Expansion index={hoIndex} title={"Hosting"} states={this.state.expand} toggle={this.expand}/></th>
                        <th className="SummaryStatusTitle">Email</th>
                        <th className="SummaryStatusTitle">Registrar</th>
                    </tr>
                    <tr>
                        <th className="SummaryStatusTitleBlank"></th>
                        <th className="SummaryStatusTitleBlank"></th>

                        <th className="SummaryStatusTitle">Status</th>
                        {upState && <th className="SummaryStatusTitleBlank" colSpan="3">Up % (for no. Days)</th>}

                        {!baState && <th className="SummaryStatusTitle">Latest</th>}
                        { baState && <th className="SummaryStatusTitle" colSpan="2">Latest</th>}
                        { baState && <th className="SummaryStatusTitle" colSpan="2">Oldest</th>}

                        <th className="SummaryStatusTitle">Status</th>
                        {hoState && <th className="SummaryStatusTitle">Disk</th>}
                        {hoState && <th className="SummaryStatusTitle">BW</th>}

                        <th className="SummaryStatusTitle">Status</th>

                        <th className="SummaryStatusTitle">Expiration</th>


                    </tr>
                    <tr>
                        <th className="SummaryStatusTitle">Item</th>
                        <th className="SummaryStatusTitle">Site</th>

                        <th className="SummaryStatusTitle">Now</th>
                        {upState && <th className="SummaryStatusTitle">1</th>}
                        {upState && <th className="SummaryStatusTitle">7</th>}
                        {upState && <th className="SummaryStatusTitle">30</th>}

                        {!baState && <th className="SummaryStatusTitle">All</th>}
                        { baState && <th className="SummaryStatusTitle">MySQL</th>}
                        { baState && <th className="SummaryStatusTitle">Others</th>}
                        { baState && <th className="SummaryStatusTitle">MySQL</th>}
                        { baState && <th className="SummaryStatusTitle">Others</th>}

                        <th className="SummaryStatusTitle">Now</th>
                        {hoState && <th className="SummaryStatusTitle">%</th>}
                        {hoState && <th className="SummaryStatusTitle">%</th>}

                        <th className="SummaryStatusTitle">DMARC</th>

                        <th className="SummaryStatusTitle">Date</th>


                    </tr >
                    {listing}
                </tbody>
            </table>
        ]


        return (
            <>
                {output}
            </>
        )
    }

}



class Epdsummary extends React.Component {
    constructor() {
        super();
    }



    render() { 

        console.log('Epdsummary', this.props.state.data);

        const textStyle = {
            textAlign: "center"
        };
    
        if (this.props.state.data.length === 0) {

            return (

                <Container fluid="lg">
                    <Row>
                        <Col>
                            <h1 style={textStyle}>Summary</h1>
                            <div style={textStyle}><Spinner  animation="border" /></div>
                        </Col>
                    </Row>
                </Container>
            );

        }
        else {

            return (
                <Container fluid="lg">
                    <Row>
                        <Col>
                             <h1 style={textStyle}>Summary</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <StatusInformation data={this.props.state.data} />
                        </Col>
                    </Row>
                </Container>

            );
        }
    }
}

export default Epdsummary


